import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useTranslator } from 'tradera-lang/translate';
import PAGE_TYPES from 'tradera-constants/page-types';
import pageActions from 'tradera-state/page/actions';

/**
 * Set page metadata, either with a pagemeta id or a page metadata object
 *
 * @param {string} [type]
 * @param {object} [customPageMetaData]
 */
const usePageMeta = (
    type = PAGE_TYPES.DEFAULT,
    customPageMetaData,
    setMetaTitle = true,
    metaRobots = null
) => {
    const { t } = useTranslator();
    const dispatch = useDispatch();
    useEffect(() => {
        const pageMetaData = {
            metaRobots: metaRobots,
            metaTitle: setMetaTitle ? t(`pageMeta_title_${type}`) : '',
            type,
            ...(customPageMetaData || { canonicalLink: location.pathname })
        };
        dispatch(pageActions.setPageMeta(pageMetaData));
    }, [customPageMetaData, dispatch, setMetaTitle, t, type, metaRobots]);
};

export { usePageMeta, PAGE_TYPES };
